import { FeedPostDto } from "@/api/posts/types";
import { Modal } from "@/app/(components)/Basic/Modal";
import { useState } from "react";
import { FeedUpsert } from "../../FeedUpsert";

export interface Props {
  feedPost: FeedPostDto;
  repost?: FeedPostDto;
  onSuccess: () => void;
  onClose: () => void;
}

export default function FeedEditModal({
  feedPost,
  repost,
  onSuccess,
  onClose,
}: Props) {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onModalClose = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onModalClose}
      hasCloseButton={!isLoading}
      disableClose={isLoading}
      className={"w-11/12 md:w-[720px]"}
      title="Edit post"
      smallPadding
    >
      <FeedUpsert
        id="post-edit"
        feedPost={feedPost}
        repost={repost}
        onSubmit={() => {
          setIsLoading(true);
        }}
        onSuccess={() => {
          onSuccess();
          onModalClose();
        }}
        onError={() => setIsLoading(false)}
        forceLightTheme
      />
    </Modal>
  );
}
